import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import LicenseRenewalFailSystemErrorBottomSheet from '@di-shared/features/public-service/license-renewal/LicenseRenewalFailSystemErrorBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function LicenseRenewalFailSystemErrorBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <LicenseRenewalFailSystemErrorBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
